import { formatInDisplayZone } from '@shared/lib/format-date';

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function csvFilenameStamp(date = new Date()): string {
  return formatInDisplayZone(date, 'yyyy-MM-dd_HH-mm-ss');
}

export function filenameFromDisposition(header: string | null): string | null {
  if (!header) return null;
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (encoded?.[1]) {
    try {
      return decodeURIComponent(encoded[1]);
    } catch {
      return encoded[1];
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain?.[1] ?? null;
}

export async function countCsvDataRows(blob: Blob): Promise<number> {
  const text = (await blob.text()).replace(/^\uFEFF/, '');
  const rows = text.split(/\r?\n/).filter((line) => line.trim().length > 0);
  return Math.max(0, rows.length - 1);
}

export const AUDIT_EXPORT_ROW_LIMIT = 50_000;
